/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { FileMeta } from '../model/fileMeta';
// @ts-ignore
import { FileMetaCollection } from '../model/fileMetaCollection';
// @ts-ignore
import { HandleFileUploadRequest } from '../model/handleFileUploadRequest';
// @ts-ignore
import { UpdateFileRequest } from '../model/updateFileRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class MediaEndpointsService {

    protected basePath = 'http://api.leerplus.dev.gametailors.com/cas';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param force 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteFile(gameId: string, dataPackageUid: string, uid: string, force?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteFile(gameId: string, dataPackageUid: string, uid: string, force?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteFile(gameId: string, dataPackageUid: string, uid: string, force?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteFile(gameId: string, dataPackageUid: string, uid: string, force?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling deleteFile.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling deleteFile.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling deleteFile.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (force !== undefined && force !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>force, 'force');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fetch/download a file
     * Retrieve (download) a media file with the given uid. If the file is an image. Additional parameters can be given to resize the image, or compress it using texture compression techniques (ASTC, DXT1, and DXT5).If the &#x60;{uid}/download&#x60; endpoint is used, the file will be downloaded instead of displayed in the browser (i.e. &#x60;content-disposition: attachment&#x60; header will be added).
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param width Scales the image to the given width. If the original image is smaller than the given width, the image will not be scaled up. Will only be used on image files
     * @param compression If present, the image will be compressed using the given compression type. Will only be used on image files
     * @param mode For ASTC compression only, determines the mode of the compression. Default is CL. Detailed documentation can be found [here](https://github.com/ARM-software/astc-encoder?tab&#x3D;readme-ov-file#compressing-an-image)
     * @param quality For ASTC compression only, determines the compression speed. Higher quality means slower compression but generally smaller files. Default is MEDIUM
     * @param blockDimensions For ASTC compression only, determines the block dimensions of the compression. Default is 6x6
     * @param miplevels For DXT compression only, determines the number of mip levels to generate. &#x60;mipsize&#x60; overrides this option. Default is 1 (no mip levels)
     * @param mipsize For DXT compression only. The size in pixels used to determine how many mip levels to generate. If not given, &#x60;miplevels&#x60; will be used
     * @param flip Flip the image in one or more directions
     * @param lossless Use lossless compression on this image. Enabling this will make the response take longer
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchFile(gameId: string, dataPackageUid: string, uid: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public fetchFile(gameId: string, dataPackageUid: string, uid: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public fetchFile(gameId: string, dataPackageUid: string, uid: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public fetchFile(gameId: string, dataPackageUid: string, uid: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling fetchFile.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling fetchFile.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling fetchFile.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (width !== undefined && width !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>width, 'width');
        }
        if (compression !== undefined && compression !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>compression, 'compression');
        }
        if (mode !== undefined && mode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mode, 'mode');
        }
        if (quality !== undefined && quality !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>quality, 'quality');
        }
        if (blockDimensions !== undefined && blockDimensions !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>blockDimensions, 'blockDimensions');
        }
        if (miplevels !== undefined && miplevels !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>miplevels, 'miplevels');
        }
        if (mipsize !== undefined && mipsize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mipsize, 'mipsize');
        }
        if (flip !== undefined && flip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>flip, 'flip');
        }
        if (lossless !== undefined && lossless !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>lossless, 'lossless');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fetch/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fetch/download a file
     * Retrieve (download) a media file with the given uid. If the file is an image. Additional parameters can be given to resize the image, or compress it using texture compression techniques (ASTC, DXT1, and DXT5).If the &#x60;{uid}/download&#x60; endpoint is used, the file will be downloaded instead of displayed in the browser (i.e. &#x60;content-disposition: attachment&#x60; header will be added).
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param ext 
     * @param width Scales the image to the given width. If the original image is smaller than the given width, the image will not be scaled up. Will only be used on image files
     * @param compression If present, the image will be compressed using the given compression type. Will only be used on image files
     * @param mode For ASTC compression only, determines the mode of the compression. Default is CL. Detailed documentation can be found [here](https://github.com/ARM-software/astc-encoder?tab&#x3D;readme-ov-file#compressing-an-image)
     * @param quality For ASTC compression only, determines the compression speed. Higher quality means slower compression but generally smaller files. Default is MEDIUM
     * @param blockDimensions For ASTC compression only, determines the block dimensions of the compression. Default is 6x6
     * @param miplevels For DXT compression only, determines the number of mip levels to generate. &#x60;mipsize&#x60; overrides this option. Default is 1 (no mip levels)
     * @param mipsize For DXT compression only. The size in pixels used to determine how many mip levels to generate. If not given, &#x60;miplevels&#x60; will be used
     * @param flip Flip the image in one or more directions
     * @param lossless Use lossless compression on this image. Enabling this will make the response take longer
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchFile1(gameId: string, dataPackageUid: string, uid: string, ext: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public fetchFile1(gameId: string, dataPackageUid: string, uid: string, ext: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public fetchFile1(gameId: string, dataPackageUid: string, uid: string, ext: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public fetchFile1(gameId: string, dataPackageUid: string, uid: string, ext: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling fetchFile1.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling fetchFile1.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling fetchFile1.');
        }
        if (ext === null || ext === undefined) {
            throw new Error('Required parameter ext was null or undefined when calling fetchFile1.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (width !== undefined && width !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>width, 'width');
        }
        if (compression !== undefined && compression !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>compression, 'compression');
        }
        if (mode !== undefined && mode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mode, 'mode');
        }
        if (quality !== undefined && quality !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>quality, 'quality');
        }
        if (blockDimensions !== undefined && blockDimensions !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>blockDimensions, 'blockDimensions');
        }
        if (miplevels !== undefined && miplevels !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>miplevels, 'miplevels');
        }
        if (mipsize !== undefined && mipsize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mipsize, 'mipsize');
        }
        if (flip !== undefined && flip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>flip, 'flip');
        }
        if (lossless !== undefined && lossless !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>lossless, 'lossless');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/fetch/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}.${this.configuration.encodeParam({name: "ext", value: ext, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Fetch/download a file
     * Retrieve (download) a media file with the given uid. If the file is an image. Additional parameters can be given to resize the image, or compress it using texture compression techniques (ASTC, DXT1, and DXT5).If the &#x60;{uid}/download&#x60; endpoint is used, the file will be downloaded instead of displayed in the browser (i.e. &#x60;content-disposition: attachment&#x60; header will be added).
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param download 
     * @param width Scales the image to the given width. If the original image is smaller than the given width, the image will not be scaled up. Will only be used on image files
     * @param compression If present, the image will be compressed using the given compression type. Will only be used on image files
     * @param mode For ASTC compression only, determines the mode of the compression. Default is CL. Detailed documentation can be found [here](https://github.com/ARM-software/astc-encoder?tab&#x3D;readme-ov-file#compressing-an-image)
     * @param quality For ASTC compression only, determines the compression speed. Higher quality means slower compression but generally smaller files. Default is MEDIUM
     * @param blockDimensions For ASTC compression only, determines the block dimensions of the compression. Default is 6x6
     * @param miplevels For DXT compression only, determines the number of mip levels to generate. &#x60;mipsize&#x60; overrides this option. Default is 1 (no mip levels)
     * @param mipsize For DXT compression only. The size in pixels used to determine how many mip levels to generate. If not given, &#x60;miplevels&#x60; will be used
     * @param flip Flip the image in one or more directions
     * @param lossless Use lossless compression on this image. Enabling this will make the response take longer
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchFile2(gameId: string, dataPackageUid: string, uid: string, download: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public fetchFile2(gameId: string, dataPackageUid: string, uid: string, download: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public fetchFile2(gameId: string, dataPackageUid: string, uid: string, download: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public fetchFile2(gameId: string, dataPackageUid: string, uid: string, download: string, width?: number, compression?: 'ASTC' | 'DXT1' | 'DXT5', mode?: 'CL' | 'CS' | 'CH' | 'CHigh', quality?: 'FASTEST' | 'FAST' | 'MEDIUM' | 'THOROUGH' | 'VERYTHOROUGH' | 'EXHAUSTIVE', blockDimensions?: string, miplevels?: number, mipsize?: number, flip?: 'HORIZONTAL' | 'VERTICAL' | 'BOTH', lossless?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling fetchFile2.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling fetchFile2.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling fetchFile2.');
        }
        if (download === null || download === undefined) {
            throw new Error('Required parameter download was null or undefined when calling fetchFile2.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (width !== undefined && width !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>width, 'width');
        }
        if (compression !== undefined && compression !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>compression, 'compression');
        }
        if (mode !== undefined && mode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mode, 'mode');
        }
        if (quality !== undefined && quality !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>quality, 'quality');
        }
        if (blockDimensions !== undefined && blockDimensions !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>blockDimensions, 'blockDimensions');
        }
        if (miplevels !== undefined && miplevels !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>miplevels, 'miplevels');
        }
        if (mipsize !== undefined && mipsize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>mipsize, 'mipsize');
        }
        if (flip !== undefined && flip !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>flip, 'flip');
        }
        if (lossless !== undefined && lossless !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>lossless, 'lossless');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "download", value: download, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFileMeta(gameId: string, dataPackageUid: string, uid: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<FileMeta>;
    public getFileMeta(gameId: string, dataPackageUid: string, uid: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FileMeta>>;
    public getFileMeta(gameId: string, dataPackageUid: string, uid: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FileMeta>>;
    public getFileMeta(gameId: string, dataPackageUid: string, uid: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling getFileMeta.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling getFileMeta.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling getFileMeta.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<FileMeta>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gameId 
     * @param dataPackageUid 
     * @param type 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilesMetaOfDataPackage(gameId: string, dataPackageUid: string, type?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<FileMetaCollection>;
    public getFilesMetaOfDataPackage(gameId: string, dataPackageUid: string, type?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FileMetaCollection>>;
    public getFilesMetaOfDataPackage(gameId: string, dataPackageUid: string, type?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FileMetaCollection>>;
    public getFilesMetaOfDataPackage(gameId: string, dataPackageUid: string, type?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling getFilesMetaOfDataPackage.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling getFilesMetaOfDataPackage.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>type, 'type');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<FileMetaCollection>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gameId 
     * @param dataPackageUid 
     * @param alt 
     * @param name 
     * @param handleFileUploadRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public handleFileUpload(gameId: string, dataPackageUid: string, alt?: string, name?: string, handleFileUploadRequest?: HandleFileUploadRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<FileMeta>;
    public handleFileUpload(gameId: string, dataPackageUid: string, alt?: string, name?: string, handleFileUploadRequest?: HandleFileUploadRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FileMeta>>;
    public handleFileUpload(gameId: string, dataPackageUid: string, alt?: string, name?: string, handleFileUploadRequest?: HandleFileUploadRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FileMeta>>;
    public handleFileUpload(gameId: string, dataPackageUid: string, alt?: string, name?: string, handleFileUploadRequest?: HandleFileUploadRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling handleFileUpload.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling handleFileUpload.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (alt !== undefined && alt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>alt, 'alt');
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<FileMeta>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: handleFileUploadRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param gameId 
     * @param dataPackageUid 
     * @param uid 
     * @param alt 
     * @param name 
     * @param tags 
     * @param note 
     * @param updateFileRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFile(gameId: string, dataPackageUid: string, uid: string, alt?: string, name?: string, tags?: string, note?: string, updateFileRequest?: UpdateFileRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<FileMeta>;
    public updateFile(gameId: string, dataPackageUid: string, uid: string, alt?: string, name?: string, tags?: string, note?: string, updateFileRequest?: UpdateFileRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FileMeta>>;
    public updateFile(gameId: string, dataPackageUid: string, uid: string, alt?: string, name?: string, tags?: string, note?: string, updateFileRequest?: UpdateFileRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FileMeta>>;
    public updateFile(gameId: string, dataPackageUid: string, uid: string, alt?: string, name?: string, tags?: string, note?: string, updateFileRequest?: UpdateFileRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling updateFile.');
        }
        if (dataPackageUid === null || dataPackageUid === undefined) {
            throw new Error('Required parameter dataPackageUid was null or undefined when calling updateFile.');
        }
        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling updateFile.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (alt !== undefined && alt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>alt, 'alt');
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (tags !== undefined && tags !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tags, 'tags');
        }
        if (note !== undefined && note !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>note, 'note');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/game/${this.configuration.encodeParam({name: "gameId", value: gameId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/media/${this.configuration.encodeParam({name: "dataPackageUid", value: dataPackageUid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "uid", value: uid, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<FileMeta>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: updateFileRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
